module.exports = __webpack_public_path__ + "static/media/Home.39ad162a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NavIcons/Home.png
// module id = 590
// module chunks = 0